/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import type { ComponentPropsWithRef, ElementType, ReactElement } from "react";
import { forwardRef } from "react";
import type { ClayProps } from "./Clay.types";

export type ClayComponent = <C extends ElementType = "div">(
  props: ClayProps<C> & {
    ref?: ComponentPropsWithRef<C>["ref"];
  },
) => ReactElement | null;

const Clay: ClayComponent = forwardRef(
  <E extends ElementType>(
    {
      children,
      className,
      _hover,
      _active,
      _after,
      _before,
      _focus,
      size,
      width,
      height,
      shape,
      sx,
      as,
      native,
      ...props
    }: ClayProps<E>,
    ref: ComponentPropsWithRef<E>["ref"],
  ) => {
    const Element = as || "div";

    return (
      <Element
        ref={ref}
        className={className}
        css={{
          width: size || width,
          height: size || height,
          ...(shape === "circle" && {
            borderRadius: vars.rounded.full,
          }),
          "&:hover": _hover,
          "&:active": _active,
          "&:after": _after,
          "&:before": _before,
          "&:focus": _focus,
          ...props,
          ...sx,
        }}
        {...native}
      >
        {children}
      </Element>
    );
  },
);

const ClayNameSpace = Object.assign(Clay, { displayName: "Clay" });

export { ClayNameSpace as Clay };
